import React from "react";

const OrderAutomationModeIcon = ({ automatic, ...rest }) =>
  automatic ? (
    <i
      className="icon c-OrderAutomationModeIcon automatic"
      title={I18n.humanAttributeName("order", "automatic")}
      {...rest}
    >
      <span className="c-OrderAutomationModeIcon-text">
        {I18n.t("papp.order.automatic_icon", { defaultValue: "A" })}
      </span>
    </i>
  ) : (
    <i className="icon c-OrderAutomationModeIcon manual" title={I18n.humanAttributeName("order", "manual")} {...rest}>
      <span className="c-OrderAutomationModeIcon-text">{I18n.t("papp.order.manual_icon", { defaultValue: "M" })}</span>
    </i>
  );

export default OrderAutomationModeIcon;



// WEBPACK FOOTER //
// ./src/lib/components/OrderAutomationModeIcon.jsx